export const START_SEARCH = 'Type to start searching';
export const START_SEARCH_TWO_CHARS = 'Type two or more characters';
export const NO_RESULTS = 'No results found';
export const ERROR = 'Something went wrong';
export const SUBMIT_PROVIDER_ERROR = 'Please enter submitting provider';
